import store from '../store/Store';
import actionTypes from '../actionTypes/actionTypes';

async function resize(data) {
	const action = {
		type: actionTypes.RESIZE,
		data
	};

	store.dispatch(action);
}

async function changeIconHover(data) {
	const action = {
		type: actionTypes.CHANGE_ICON_HOVER,
		data
	};

	store.dispatch(action);
}

const navigationActions = {
	resize,

	/* ICON HOVER */
	changeIconHover
}

export default navigationActions;